<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{ width: '90vw', maxWidth: '600px' }"
  (onHide)="onHide()"
>
  <ng-template pTemplate="header"><span translate>MANAGE_QR_CODE</span></ng-template>
  <ng-container *ngIf="qrCodeData; else emptyQrCode">
    <ng-container
      *ngTemplateOutlet="isRevoking ? revokeConfirmBody : qrCodeBody"
    ></ng-container>
  </ng-container>
</p-dialog>

<!-- View 1: Empty QR code -->
<ng-template #emptyQrCode>
  <div class="p-fluid">
    <p translate>GENERATE_QR_CODE_DESCRIPTION</p>
  </div>
  <div class="qr-placeholder">
    <p translate>NO_QR_CODE_GENERATED</p>
  </div>
  <div
    class="d-grid d-md-flex justify-content-md-center qr-footer empty-qr-footer"
  >
    <div class="d-flex flex-column">
      <label for="expirationDate" translate>OPTIONAL_EXPIRATION_DATE</label>
      <p-datepicker
        id="expirationDate"
        [(ngModel)]="expirationDate"
        [showClear]="true"
        [minDate]="minDate"
        appendTo="body"
        dateFormat="dd/mm/yy"
        showIcon="true"
        styleClass="dateField"
      ></p-datepicker>
    </div>

    <button class="btn btn-success" (click)="createQrCode()">
      <i class="pi pi-plus"></i>
      <span translate>CREATE_QR_CODE</span>
    </button>
  </div>
</ng-template>

<!-- View 2: QR code with revoke and print buttons -->
<ng-template #qrCodeBody>
  <div class="p-fluid qr-code-info">
    <div class="p-field">
      <strong><span translate>QR_CODE_GENERATED_AT</span>: </strong>
      <span>{{
        qrCodeData?.Created.CreatedOn | date: "dd.MM.yyyy HH:mm"
      }}</span>
    </div>
    <div class="p-field">
      <strong><span translate>EXPIRATION_DATE</span>: </strong>
      <span>{{ displayExpirationDate() }}</span>
    </div>
  </div>
  <div class="d-grid d-md-flex justify-content-md-center qr-code-container">
    <qrcode
      #qrCode
      [qrdata]="qrCodeData?.QrCodeUrl"
      [width]="256"
      [errorCorrectionLevel]="'M'"
    ></qrcode>
  </div>
  <div class="d-grid d-md-flex justify-content-md-center qr-footer">
    <button class="btn btn-danger" (click)="onRevokeQrCode()">
      <i class="pi pi-trash"></i>
      <span translate>REVOKE_QR_CODE</span>
    </button>
    <button class="btn btn-primary" (click)="onPrintQrCode()">
      <i class="pi pi-print"></i>
      <span translate>PRINT_QR_CODE</span>
    </button>
  </div>
</ng-template>

<!-- View 3: Revoke confirmation with cancel and revoke buttons -->
<ng-template #revokeConfirmBody>
  <div class="p-fluid qr-code-info">
    <i class="fa fa-exclamation-triangle qr-warning-icon"></i>
    <p translate>REVOKE_QR_CODE_CONFIRMATION</p>
    <p style="text-decoration: underline" translate>
      NEW_QR_CODE_IF_REENABLE_MESSAGE
    </p>
  </div>
  <div class="d-grid d-md-flex justify-content-md-center qr-footer">
    <button class="btn btn-secondary" (click)="onCancelRevoke()">
      <span translate>CANCEL</span>
    </button>
    <button class="btn btn-danger" (click)="onConfirmRevoke()">
      <i class="pi pi-trash"></i>
      <span translate>CONFIRM</span>
    </button>
  </div>
</ng-template>


<kuba-busy [busy]="isLoading" message="PROCESSING"></kuba-busy>

